module.exports = __webpack_public_path__ + "static/media/rs.14899009.svg";